// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.delete-well {\n    display: flex;\n    justify-content: flex-end;\n\t  align-items: center;\n    grid-gap: 10px;\n    margin-top: 15px;\n}\n.delete-cross {\n    cursor: pointer;\n}\n.input-uid {\n    width: 75px;\n}\n.input-error {\n    border: 1px solid red;\n    box-shadow: 0 0 3px 1px rgba(255, 0, 0, 0.7);\n}\n", ""]);
// Exports
module.exports = exports;
